import {
  CostCenterCreateResponse,
  CostCenterPayload,
  CostCenterResponse,
  CostCentersResponse,
  Id,
  Options,
  Resource
} from 'services/api';

import Company from './Company.service';

export default class CostCenter extends Company {
  private static instance: CostCenter;

  private constructor(options: Options) {
    /* istanbul ignore next */
    super(options);
  }

  /**
   * This return the singleton instance of the class
   * @param {Options} options
   */
  public static getInstance(options: Options) {
    if (!this.instance) {
      this.instance = new this(options);
    }
    return this.instance;
  }

  /**
   * Get a list of company Cost Centers
   * @param {Id} [company_id] (optional) company id
   */
  list(params?: Record<string, any>, company_id?: Id) {
    return this.getEntities<CostCentersResponse>(
      Resource.CostCenters,
      params,
      company_id
    );
  }

  /**
   * Get a cost center by id
   * @param {Id} id cost center id
   * @param {Id} [company_id] (optional) company id
   */
  get(id: Id, company_id?: Id) {
    return this.getEntity<CostCenterResponse>(
      Resource.CostCenter,
      id,
      company_id
    );
  }

  /**
   * Delete a cost center by id
   * @param {Id} id cost center id
   * @param {string} payload.name name of cost center
   * @param {string} payload.state state of cost center (active/inactive)
   * @param {Id} [company_id] (optional) company id
   */
  create(payload: CostCenterPayload, company_id?: Id) {
    return this.createEntity<CostCenterCreateResponse, CostCenterPayload>(
      Resource.CostCenter,
      payload,
      company_id
    );
  }

  /**
   * Delete a cost center by id
   * @param {Id} id cost center id
   * @param {Id} [company_id] (optional) company id
   */
  delete(id: Id, company_id?: Id) {
    return this.deleteEntity(Resource.CostCenter, id, company_id);
  }

  /**
   * update a cost center by id
   * @param {Id} id cost center id
   * @param {string} payload.name name of cost center
   * @param {string} payload.state state of cost center (active/inactive)
   * @param {Id} [company_id] (optional) company id
   */
  update(id: Id, payload: CostCenterPayload, company_id?: Id) {
    return this.updateEntity<CostCenterPayload>(
      Resource.CostCenter,
      id,
      payload,
      company_id
    );
  }
}
